<template>
  <span @contextmenu="show">
    <v-app style="overflow-x: hidden !important;" class="overflow-hidden">
      <Navbar  @snackbarNotification="getSnack" />
      <v-content style="background:#fafafa;">
        <transition :name="transitionName"> 
          <router-view
            @snackbarNotification="getSnack"
          ></router-view>
        </transition>
      </v-content>
      <cartDialog v-if="false" @snackbarNotification="getSnack" />

      <NotificationPopup 
        :popup="popup"
        @dismissPopup="dismissPopup"
        :loading="loading"
      />

      <ThankYou />
      <Footer />

      <v-snackbar v-model="snackbar" :color="type" :timeout="4000" bottom left>
        <span :class="`${ arabic ? 'arFont' : '' }`">{{ snackbarContent }}</span>
        <v-btn color="white" dark text small @click="snackbar = false">
          <v-icon size="12">close</v-icon>
        </v-btn>
      </v-snackbar>
      <GlobalSnackBar />
      <div class="wasupport" v-if="isLogin">
        <a href="https://api.whatsapp.com/send?phone=447883307413">
          <img height="60px" src="/images/WhatsApp.png">
        </a>
      </div>
      <v-menu
      v-model="rightmenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      width="250"
    >
      <v-card color="primary" width="250">
        <v-card-text>
          <v-row class="align-center">
            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1 white--text`" style="font-size:11px;text-transform:uppercase;">
              الانتقال الى:
            </v-col>
            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`" v-for="(item, ii) in rightitems" :key="ii+'-items'">
              <v-btn text small block color="white" @click="goTo(item.path)">{{item.title}}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
    </v-app>
  </span>
</template>

<script>
import GlobalSnackBar from '@/components/GlobalSnackBar'
import Footer from '@/components/footer'
import Navbar from './components/Navbar'
import cartDialog from './components/cartDialog'
import ThankYou from './components/ThankYou'
import Verification from './components/Verification'

import axios from 'axios';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
const headers = {'Accept': 'application/json'};
import {firebase, db, auth, db2} from '@/fb'
import NotificationPopup from './components/NotificationPopup.vue'


export default {
  components: { Navbar, cartDialog, ThankYou, Footer, Verification, NotificationPopup, GlobalSnackBar },
  name: 'App',
  data () {
    return {
      popups: [],
      loading:false,
      transitionName:null,
      snackbar:false,
      snackbarContent:'',
      type:null,
      pinname:null,
      fieldTypes:{
        password:'text',
      },
      rightmenu:false,
      x:0,
      y:0,
      rightitems: [
        { title: 'حسابي', path:'/account' },
        { title: 'منتجاتي', path:'/catalog' },
        { title: 'طلباتي', path:'/leads' },
        { title: 'الاشعارات', path:'/notifications' },
      ],
    }
  },
  methods: {
    async dismissPopup(popup) {
      this.loading = true
      const resp = await this.$store.dispatch('putResource', {resource: `/popups/${popup.id}/dismiss`})
      const index = this.popups.indexOf(popup)
      if (index > -1) {
        this.popups.splice(index, 1);
      }
      this.loading = false
    },
    show(e) {
      // e.preventDefault()
      // this.rightmenu = false
      // this.x = e.clientX
      // this.y = e.clientY
      // this.$nextTick(() => {
      //   this.rightmenu = true
      // })
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getName() {
      return this.pinname = randomString(28, '#Aa')
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    eraseCookie(name) {   
      document.cookie = name+'=; Max-Age=-99999999;';  
    },
    getSnack (text, type) {
      this.snackbar = true
      this.snackbarContent = text
      this.type = type
    },
    showSnackbar (text, type) {
      this.$emit('snackbarNotification', text, type)
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadScrollStyle(theme){
      let b = `
        ::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
            background-color: ${theme.secondary};
        }

        ::-webkit-scrollbar {
          width: 10px;
          background-color: ${theme.primary};
        }

        ::-webkit-scrollbar-thumb {
          background-color: ${theme.primary};
          border-radius:  0 0 10px 10px; 
        }`
        let a = document.createElement('style')
        a.innerHTML = b
        document.head.append(a)
    },
    getNotifications(){
      setInterval(x=>{
        if(this.$store.state.centralLogin) {
          this.$store.dispatch('checkAuth')
          // this.$store.dispatch('getNotifications')
        }
      }, 5*60000)
      // setInterval(x=>{
      //   if(this.$store.state.centralLogin) {
      //   }
      // }, 5* 60 * 1000)
    },
    async checkState(){
      return new Promise(async (res, rej)=>{
        let noGate = ['home', 'login', 'register', 'toc', 'verify', 'maillist', 'consult','trackorders']
        // console.log('app check status', this.$route.name)
        let hostname = window.location.hostname
        let access_token = this.getCookie('_MJC')
        if(access_token) {
          this.$store.state.access_token = access_token
          let a = await this.$store.dispatch('getUser')
          if((!a || a.error)) {
            if(hostname.includes('app')) {
              this.goTo('/login')
              return res(true)
            }
            this.goTo('/home')
            res(false)
          } else {
            this.$store.state.user = a
            this.$store.state.centralLogin = true
            this.$store.dispatch('getNotifications')
            // console.log('last', localStorage.last)
            this.getNotifications()
            res(true)
          }
        } else if(noGate.includes(this.$route.name)) {
          res(false)
        } else {
          if (hostname.includes('app')) {
            this.goTo('/login')
            return res(true)
          }
          this.goTo('/home')
          res(false)
        }
      })
    },
  }, 
  computed: {
    popup() {
      if (!this.popups) return null
      
      if (this.popups.length == 0) return null

      return this.popups[0]
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    getLanguage(){
      if(this.$store.state.language == 'ar') {
        this.$vuetify.rtl = true
      }
      return this.$store.state.language
    },
    site(){
      if(this.$store.state.site) {
        let site = this.$store.state.site
        this.$vuetify.theme.currentTheme.primary = site.theme.light.primary
        this.$vuetify.theme.currentTheme.secondary = site.theme.light.secondary
        this.$vuetify.theme.currentTheme.accent = site.theme.light.accent
        this.$vuetify.theme.currentTheme.error = site.theme.light.error
        this.$vuetify.theme.currentTheme.info = site.theme.light.info
        this.$vuetify.theme.currentTheme.success = site.theme.light.success
        this.$vuetify.theme.currentTheme.warning = site.theme.light.warning
        this.loadScrollStyle(site.theme.light)
        return site
      } else {
        return {}
      }
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  watch: {
    async isLogin(login){
      // console.log('isLogin changed')
      await this.checkState()
    },
    getLanguage(){},
    site(){},
    $route (to, from){
      localStorage.last = to.path
      let path = to.path
      let user = {...this.$store.state.user}
      let role = user.role
      
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    },
  },
  async created() {
    var w = window.location.origin
    var base_url = w.includes('localhost') || w.includes('firebase') || w.includes('web.app') || w.includes('ninjasellers.com') ? 'https://yervip.com' : window.location.origin
    // console.log(base_url)
    if(process.env.VUE_APP_VARS && process.env.VUE_APP_VARS === 'local') {
      base_url = 'http://127.0.0.1:8000'
    }
    this.$store.dispatch('setSettingsBase', {base:base_url})
    this.$store.dispatch('firstLoad')
    
    let a = await this.checkState()
    // console.log('adding lsnr')
    db2.ref('ninja_notifications').on('child_added', async (snapshot)=>{
      const data = snapshot.val();
      this.$store.state.notify_board = data
    })
    db2.ref('ninja_notifications').on('child_changed', async (snapshot)=>{
      const data = snapshot.val();
      this.$store.state.notify_board = data
    })
  },
  async mounted(){
    this.popups = await this.$store.dispatch('getResource', {resource: '/popups'})
  },
  destroyed(){
  }
}
</script>
<style>
/*  */
.RTL {
  direction: rtl !important;
  
}
.arFont {
  font-family: 'Tajawal', sans-serif !important;
  letter-spacing: unset !important;
}
.enFont {
  font-family: 'Poppins', sans-serif;
}
.arTitle {
  font-family: 'Tajawal', sans-serif !important;
  letter-spacing: unset !important;
  font-size: 1.25rem!important;
  font-weight: 500;
  letter-spacing: .0125em!important;
}
.solidCard {
  background-image: url("/resume_back_2.png");
  background-size: cover;
}
.wasupport {
    z-index: 9999999999999999;
    bottom: 5px;
    left: 9px;
    position: fixed;
}
.grecaptcha-badge {
  visibility: hidden !important;
}
</style>
